import React from 'react';
import './TaglineLine.css';

interface TaglineLineProps {
  children: React.ReactNode;
  className?: string;
}

const TaglineLine: React.FC<TaglineLineProps> = ({ children, className = '' }) => {
  return (
    <div className={`tagline-line ${className}`}>
      {children}
      <span className="dot"></span>
    </div>
  );
};

export default TaglineLine;